const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// fadeAnimation
// ----- BOTH
// ------------------------------------------------------------------------
const fadeAnimation = () => {
  $(window).on('scroll', function(){
    $('.anime-Fade').each(function(){
      var imagePosition = $(this).offset().top;
      var scrollVolume  = $(window).scrollTop();
      var windowWidth   = $(window).width();
      var windowHeight  = $(window).height();
      if(windowWidth > breakPoint){
        if(scrollVolume > imagePosition - windowHeight + windowHeight / 3.25){
          $(this).addClass('anime-Fade-On');
        }
      } else {
        if(scrollVolume > imagePosition - windowHeight + windowHeight / 4){
          $(this).addClass('anime-Fade-On');
        }
      }
    })
  });
}



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};






export {
  fadeAnimation,
  anchorLink
}



// WEBPACK FOOTER //
// module.js